/* global currentProduct, buildsetHasVariants, buildsetVariants, ga, __gaTracker */
(function ($)
{
    if (typeof BOLD != 'undefined')
    {
        var boldCheck = setInterval(function ()
        {
            if (typeof BOLD.common.eventEmitter != 'undefined')
            {
                var event;
                if (document.createEvent)
                {
                    event = document.createEvent('HTMLEvents');
                    event.initEvent('BOLDInitialized', true, true);
                    event.eventName = 'BOLDInitialized';
                    document.dispatchEvent(event);
                }
                else
                {
                    event = document.createEventObject();
                    event.eventName = 'BOLDInitialized';
                    event.eventType = 'BOLDInitialized';
                    document.fireEvent('on' + event.eventType, event);
                }
                clearInterval(boldCheck);
            }
        }, 100);
    }
    window.ox = window.ox || {};
    var initial = ox.upsells || {};
    ox.upsells = {
        presented: null,
        displayed: false,
        init: function ()
        {
            $(document).on('BOLDInitialized', ox.upsells.boldLoaded);
        },
        boldLoaded: function ()
        {
            BOLD.common.settings.log_events = false;
            BOLD.common.settings.log_event_data = false;
            ox.upsells.running = false;
            ox.upsells.checkingOut = false;
            ox.upsells.loadCart();
            if (typeof buildsetVariants != 'undefined' || typeof buildsetHasVariants != 'undefined')
            {
                BOLD.common.eventEmitter.addListener('BOLD_UPSELL_add_to_cart_cloned', ox.upsells.hideClonedChooseFlavor);
            }
            BOLD.common.eventEmitter.addListener('BOLD_EVENTQUEUE_before_run', ox.upsells.beforeUpsell);
            BOLD.common.eventEmitter.addListener('BOLD_EVENTQUEUE_after_run', ox.upsells.afterUpsell);
        },
        loadCart: function ()
        {
            if (typeof BOLD == 'undefined')
            {
                ox.upsells.enableCheckoutButton();
            }
            else
            {
                $.ajax({
                    type: 'GET',
                    url: '/cart.js',
                    dataType: 'json',
                    async: false,
                    success: function (cart)
                    {
                        ox.upsells.triggerCartLoaded(cart);
                    }
                });
            }
        },
        triggerCartLoaded: function (cart)
        {
            if (BOLD.common.eventEmitter != undefined)
            {
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
            }
        },
        hideClonedChooseFlavor: function (e)
        {
            $('.bold_clone').hide();
            $('.bold_hidden').removeAttr('style').removeClass('bold_hidden');
        },
        beforeUpsell: function (e)
        {
            ox.upsells.running = true;
            if (e.event.name === 'Upsell Offer')
            {
                var offer_product_sku = null;
                var variantId = parseInt($(e.buttons.original).closest('form').find('[name="id"]').val());
                var offer = ox.upsells.getOffer(e.queueName, variantId);
                if (e.queueName === 'checkout')
                {
                    ox.upsells.checkingOut = true;
                }
                if (offer && typeof offer.products != 'undefined')
                {
                    offer_product_sku = ox.upsells.getOfferProductSku(offer.products, typeof variantId != 'undefined' ? variantId : null);
                }
                var offer_selected = ox.upsells.selectUpsellTemplate(offer_product_sku);
                ox.upsells.presented = offer.products[offer_selected];
                $('body').on('DOMSubtreeModified', function ()
                {
                    if ($('.bold-product').length == offer_product_sku.length && !ox.upsells.displayed)
                    {
                        ox.upsells.displayed = true;
                        var tracker;
                        if (typeof ga != 'undefined')
                        {
                            if (typeof ga == 'function')
                            {
                                tracker = ga;
                            }
                            else if (typeof ga.getAll != 'undefined')
                            {
                                tracker = ga.getAll()[0];
                            }
                        }
                        else if (typeof __gaTracker != 'undefined')
                        {
                            tracker = __gaTracker;
                        }
                        if (typeof tracker != 'undefined')
                        {
                            ox.upsells.track(tracker, 'shop_xsell', 'show_offer', ox.upsells.presented.handle);
                            $('.bold-product .add-to-cart').click(function ()
                            {
                                ox.upsells.track(tracker, 'shop_xsell', 'accept_offer', ox.upsells.presented.handle);
                                $('#bold-upsell-modal-window').off('DOMNodeRemoved');
                            });
                            $('#bold-upsell-modal-window').on('DOMNodeRemoved', function (e)
                            {
                                if (e.target == this)
                                {
                                    ox.upsells.track(tracker, 'shop_xsell', 'decline_offer', ox.upsells.presented.handle);
                                    $('#bold-upsell-modal-window').off('DOMNodeRemoved');
                                }
                            });

                        }
                    }
                });
            }
        },
        afterUpsell: function (e)
        {
            ox.upsells.running = false;
        },
        getOffer: function (offerType, variantId)
        {
            var data, requestUri;
            if (offerType === 'checkout')
            {
                data = {
                    data: {
                        cart: BOLD.upsell.app.upsellHelper.getFormattedCartData()
                    }
                };
                requestUri = '/get_checkout_offer';
            }
            else
            {
                data = {
                    data: {
                        productId: currentProduct.id,
                        variantId: variantId
                    }
                };
                requestUri = '/get_product_offer';
            }

            var offer = null;
            $.ajax({
                type: 'POST',
                url: BOLD.upsell.path + BOLD.common.Shopify.shop.permanent_domain + requestUri,
                dataType: 'json',
                async: false,
                data: JSON.stringify(data),
                success: function (response)
                {
                    offer = response;
                }
            });
            return offer;
        },
        getOfferProductSku: function (products, currentVariantId)
        {
            var sku = [];
            if (products.length > 0)
            {
                products.forEach(function (e)
                {
                    $.ajax({
                        type: 'GET',
                        url: ' /products/' + e.handle + '.js',
                        dataType: 'json',
                        async: false,
                        success: function (product)
                        {
                            if (product.variants.length === 1 || !currentVariantId)
                            {
                                var pSku = product.variants[0].sku.toLowerCase();
                                var m = product.handle.match(/-[0-9*]$/);
                                if (m)
                                {
                                    pSku += m[0];
                                }
                                sku.push(pSku);
                            }
                            else
                            {
                                product.variants.forEach(function (v)
                                {
                                    if (v.id === currentVariantId)
                                    {
                                        var vSku = v.sku.toLowerCase();
                                        var m = product.handle.match(/-[0-9*]$/);
                                        if (m)
                                        {
                                            vSku += m[0];
                                        }
                                        sku.push(vSku);
                                        return false;
                                    }
                                });
                            }
                        }
                    });
                });
            }
            return sku;
        },
        selectUpsellTemplate: function (sku)
        {
            var selected = 0;
            if (sku.length > 0)
            {
                selected = Math.floor(Math.random() * sku.length);
                var selectedSku = sku[selected];
                if (selectedSku && typeof ox.upsells.templates[selectedSku] != 'undefined')
                {
                    var template = ox.upsells.templates[selectedSku];
                    if (BOLD.common.settings.log_events && BOLD.common.settings.log_event_data)
                    {
                        console.debug('Offer Template', 'upsells-' + selectedSku);
                    }
                }
                else
                {
                    var template = ox.upsells.templates.default;
                    if (BOLD.common.settings.log_events && BOLD.common.settings.log_event_data)
                    {
                        console.debug('Offer Template', 'upsells-default');
                    }
                }
                switch (sku.length)
                {
                    case 0:
                    case 1:
                        BOLD.upsell.templates['upsellSingleProduct'] = template;
                        break;
                    case 2:
                        BOLD.upsell.templates['upsellTwoProducts'] = template;
                        break;
                    default:
                        BOLD.upsell.templates['upsellThreeOrMoreProducts'] = template;
                        break;
                }
                if (sku.length > 1)
                {
                    $('body').append('<style>#product_list > article{display:none;}#product_list > article:nth-child(' + (selected + 1) + '){display:block;}</style>');
                }
            }
            else
            {
                BOLD.upsell.templates['upsellSingleProduct'] = ox.upsells.templates.default;
                if (BOLD.common.settings.log_events && BOLD.common.settings.log_event_data)
                {
                    console.debug('Offer Template', 'upsells-default');
                }
            }
            return selected;
        },
        enableCheckoutButton: function ()
        {
            ox.upsells.toggleCheckoutButton(true);
        },
        toggleCheckoutButton: function (show)
        {
            $('.checkout-link').prop('disabled', !show);
            $('.checkout-link .checkout-text').toggleClass('hidden', !show);
            $('.checkout-link .loading-dots').toggleClass('hidden', show);
        },
        processData: function (data)
        {
            data.products.forEach(function (e, i)
            {
                e.variants.forEach(function (ee, ii)
                {
                    ee.price_money = ee.price / 100;
                    ee.compare_at_price_money = ee.compare_at_price / 100;
                    ee.price_off_money = (ee.compare_at_price - ee.price) / 100;
                    ee.price_off_discount = Math.round((ee.compare_at_price - ee.price) / ee.compare_at_price * 100);
                });
            });
            if (BOLD.common.settings.log_events && BOLD.common.settings.log_event_data)
            {
                console.debug('Offer Data', data);
            }
            return data;
        },
        validateCheckoutOffer: function (data)
        {
            if (typeof ox.cartItems != 'undefiend' && ox.cartItems.length > 0)
            {
                var cartSkus = ox.cartItems.map(function (e)
                {
                    return e.sku;
                });
                var offer = ox.upsells.getOffer('checkout');
                var offerProduct = null;
                if (typeof offer.products != 'undefined' && offer.products.length > 0)
                {
                    $.ajax({
                        type: 'GET',
                        url: '/products/' + offer.products[0].handle + '.js',
                        dataType: 'json',
                        async: false,
                        success: function (data)
                        {
                            offerProduct = data;
                        }
                    });
                }
                if (offerProduct && cartSkus.indexOf(offerProduct.variants[0].sku) > -1)
                {
                    data.offer_exist = false;
                }
            }
            if (BOLD.common.settings.log_events && BOLD.common.settings.log_event_data)
            {
                console.debug('Checkout Offer Valid', data);
            }
            return data;
        },
        track: function (t, c, a, l)
        {
            if (typeof t == 'function')
            {
                t('send', 'event', c, a, l);
            }
            else if (typeof t == 'object' && typeof t.send == 'function')
            {
                t.send('event', c, a, l);
            }
        }
    };
    if (typeof Object.assign === 'undefined')
    {
        $.each(initial, function (k, v)
        {
            ox.upsells[k] = v;
        });
    }
    else
    {
        ox.upsells = Object.assign(ox.upsells, initial);
    }
    ox.upsells.init();
    window.onerror = function (e)
    {
        if ($('#ajax-cart-sidebar').hasClass('open'))
        {
            $('.checkout-link').attr('disabled', false);
        }
    };
})(jQuery);